import type { AdminCrewReportReportingCoverageProps } from "../../models/admin-crew-report.models";
import { getAdminCrewReportCoveragePresentation } from "../../utils/admin-crew-report-statistics.utils";
import AdminCrewReportDataCollectionChart from "./AdminCrewReportDataCollectionChart";
import AdminCrewReportReportedVesselsGauge from "./AdminCrewReportReportedVesselsGauge";

const AdminCrewReportReportingCoverage = ({ view, statistics }: AdminCrewReportReportingCoverageProps) => {
  const presentation = getAdminCrewReportCoveragePresentation(view, statistics);

  return (
    <section
      aria-label={view === "women" ? "Women On Board vessel coverage" : "Vessel reporting statistics"}
      data-test="admin-crew-report-reporting-coverage"
      data-testid="admin-crew-report-reporting-coverage"
      className="grid min-w-0 grid-cols-1 gap-4 md:col-span-2 md:grid-cols-2 xl:col-span-1 xl:col-start-3 xl:row-start-3 xl:ml-[min(0px,calc(24rem_-_100%))] xl:h-full xl:w-[max(100%,calc(200%_-_24rem))]"
    >
      <AdminCrewReportReportedVesselsGauge presentation={presentation} />
      <AdminCrewReportDataCollectionChart presentation={presentation} />
    </section>
  );
};

export default AdminCrewReportReportingCoverage;
